// extracted by mini-css-extract-plugin
module.exports = {"installCancel":"installCancel--GwVTi","cancelTip":"cancelTip--mtwK2","img":"img--HZp5R"};